<template>
  <div v-if="basket" >
    <div v-if="isReady && (isDirectOrder || !isInWarehouse) && (isOrderable || isDirectOrder)"
         class="d-sm-inline-block relative">
      <template v-if="!isDirectOrder && (isConfirmed && !isDirectOrder) && isCancelable">
        <v-btn
            color="primary"
            depressed
            @click="revertOrder"
        >
          <span class="icon-schliessen-klein mr-2"></span>
          <span class="pt-1">Bestellung zurücknehmen</span>
        </v-btn>
        <div class="d-flex justify-end text--primary mt-2 text-small absolute"
             v-if="!isDirectOrder && isConfirmed && stats">
          Änderungen möglich bis: {{ $moment(lockAt).format('DD.MM.YYYY HH:mm') }}
        </div>
      </template>
      <v-btn
          v-else-if="!isConfirmed || isDirectOrder"
          color="primary"
          depressed
          :disabled="isDisabled"
          @click="confirmOrder"
      >
        <span class="icon-warenkrob mr-2"></span>
        <span class="pt-1">Bestellen bei Hauptlager</span>
      </v-btn>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import {mapGetters} from "vuex";

export default {
  name: 'OrderHandlingButton',

  props: {
    livingUnitId: {
      type: Number,
      required: true
    },
  },

  computed: {
    ...mapGetters({
      basket: 'smartLogisticBasket/basket',
      basketLoading: 'smartLogisticBasket/isLoading',
      orderLockOffset: 'smartLogisticSettings/orderLockOffset',
      isDirectOrder: 'smartLogisticSettings/isDirectOrder',
      currentLivingUnit: 'smartLogisticSettings/currentLivingUnitPanel',
      suggestionsLoading: 'smartLogisticOrderSuggestion/isLoading',
      orderSuggestion: 'smartLogisticOrderSuggestion/chosenDateObject',
      directOrderBasketArticles: 'smartLogisticDirectOrder/BasketArticles',
      suggestionDates: 'smartLogisticOrderSuggestion/suggestionDates',
      isModelB: 'smartLogisticSettings/isModelB',
      isModelC: 'smartLogisticSettings/isModelC',
    }),

    stats() {
      return this.$store.getters['smartLogisticOrderSuggestion/orderStateByLinvingUnitId']({id: this.livingUnitId})
    },

    isReady() {
      return this.livingUnitId === this.currentLivingUnit && !this.suggestionsLoading && this.basket !== null && (this.isModelB || !this.basketLoading);
    },

    now() {
      return this.$moment()
    },

    dueAt() {
      return this.basket.due_at
    },

    lockAt() {
      return this.$moment(this.dueAt).subtract(this.orderLockOffset, 'seconds')
    },

    hasDirectOrderItems() {
      return this.directOrderBasketArticles.length > 0;
    },

    isAlreadyLocked() {
      return this.now.diff(this.lockAt) >= 0
    },

    getCurrentDate() {
      return this.suggestionDates.find(date => {
        return this.basket.date === date.date
      })
    },

    isOrderable() {
      if (this.isDirectOrder) {
        return true;
      }
      let date = this.getCurrentDate;
      return date ? date.isOrderable : false;
    },

    isCancelable() {
      let date = this.getCurrentDate;
      return date ? date.state !== "past" : false;
    },

    isDisabled() {
      return (this.isDirectOrder && !this.hasDirectOrderItems) || ((this.isAlreadyLocked && !this.isOrderable) && !this.isDirectOrder) || this.basket.status === 'confirmed'
    },

    isConfirmed() {
      return ['order_confirmed'].includes(this.orderSuggestion.status);
    },

    isInWarehouse() {
      return ['completed'].includes(this.orderSuggestion.status);
    }
  },

  methods: {
    confirmOrder() {
      this.$store.dispatch('smartLogisticBasket/order', {
        isDirectOrder: this.isDirectOrder,
        unit: this.livingUnitId,
        date: null
      })
    },

    async revertOrder() {
      await this.$store.dispatch('smartLogisticBasket/revert', {
        unit: this.livingUnitId,
        date: null
      });
    }
  },

  watch:{
    isDirectOrder(value) {
      if(!value && this.isModelC){
        const params = {
          unit: this.livingUnitId,
          date: null,
          resetChosenDate: true,
          loadBasket: true,
        }
        this.$store.dispatch("smartLogisticOrderSuggestion/fetch", params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-small {
  font-size: 14px;
  width: 300px;
  right: 0;
  bottom: -25px;
}

::v-deep {
  .v-btn {
    width: 100%;
  }
}
</style>
